import { createSelector, createSlice } from '@reduxjs/toolkit';

const dialogSlice = createSlice({
  name: 'dialog',
  initialState: {
    options: null,
    openedDialog: null,
  },
  reducers: {
    updateDialog: (state, { payload: { key, value } }) => {
      state.options = { ...state.options, [key]: value };
    },
    openDialog: (state, { payload: { dialogId, ...options } }) => {
      state.options = options;
      state.openedDialog = dialogId;
    },
    closeDialog: (state, action) => {
      state.openedDialog = null;
      // state.options = clearOptions ? null : state.options;
    },
  },
});

export const { openDialog, closeDialog, updateDialog } = dialogSlice.actions;
export const selectDialogOptions = createSelector(
  (state) => state.fuse,
  (state) => state.dialog.options
);
export const selectOpenedDialog = createSelector(
  (state) => state.fuse,
  (state) => state.dialog.openedDialog
);

export default dialogSlice.reducer;
